import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";

export const decrementMonthlyFreeMessages = async (user: any) => {
    if (!user) return;

    try {
        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/updateMonthlyFreeMessages`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
    } catch (error) {
        console.error(`Error writing settings: ${error}`);
    }
}
